import { Injectable, NgZone, inject } from '@angular/core';
import { GeolocationOptions } from '@capacitor/geolocation';
import { VariablesGlobalesService } from './variables-globales.service';
import { Geolocation } from '@capacitor/geolocation';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { Platform } from '@ionic/angular/standalone';
import { LlamadasAlertsService } from './llamadas-alerts.service';

@Injectable({
  providedIn: 'root'
})
export class VerificacionesService {
  variables = inject(VariablesGlobalesService);
  diagnostic = inject(Diagnostic);
  platform = inject(Platform);
  ngzone = inject(NgZone);
  alerts = inject(LlamadasAlertsService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

   /**
   * MÉTODO QUE COMPRUEBA SI EL PARAMETRO DADO COINCIDE CON LA EXPRESIÓN REGULAR
   * @param correo CORREO QUE SE VA A COMPROBAR EN EL MÉTODO
   */
    public async comprobarRegexCorreo(correo: string): Promise<boolean> {
      let correoCorrecto;
      let regexCorreo: RegExp;

      regexCorreo = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

      if (regexCorreo.test(correo)) {
        correoCorrecto = true;
      } else {
        correoCorrecto = false;
      }
      return correoCorrecto;
    }

    comprobarLocalizacionActivada(): Promise<{ resolve: boolean, posicion: GeolocationPosition }> {

      return new Promise(async (resolve, reject) => {
        console.log('Verificaciones comprobarLocalizacionActivada()');

        if ((this.platform.is('android') || this.platform.is('ios')) && !this.platform.is("mobileweb")) {
          await this.diagnostic
            .isLocationEnabled()
            .then(isEnabled => {
              if (isEnabled == true) {
                console.log('Geo activada');
                var options: GeolocationOptions = {
                  enableHighAccuracy: true,

                };
                Geolocation.getCurrentPosition(options)
                  .then((position: GeolocationPosition) => {
                    console.log("LA POSICION ES: ", position);
                    let localizacionActivada = { resolve: true, posicion: position }
                    resolve(localizacionActivada);
                  }).catch((err) => {
                    console.log("LA POSICION CON ERROR ES: ", err);
                    let localizacionActivada = { resolve: false, posicion: null }
                    resolve(localizacionActivada);
                  })
              } else {
                let localizacionActivada = { resolve: false, posicion: null }
                resolve(localizacionActivada);

                this.alerts
                  .presentAlertGPS()
                  .then(resp => {
                    console.log('No hay gps');
                    console.error('Presenta la alerta de gps');
                  })
                  .catch(err => {
                    console.error('ERROR AL OBTENER GPS ' + err);
                  });
              }
            })
            .catch(async err => {
              console.error('ERROR AL INTENTER OBTENER EL GPS ' + err);
            });

        } else {
          // OPCIONES PARA LA GEOLOCALIZACION
          var options: GeolocationOptions = {
            enableHighAccuracy: true,
          };

          this.ngzone.run(() => {
            Geolocation.getCurrentPosition(options)
              .then((position: GeolocationPosition) => {
                console.log("LA POSICION ES: ", position);
                let localizacionActivada = { resolve: true, posicion: position }
                resolve(localizacionActivada);
              }).catch((err) => {
                console.log("LA POSICION CON ERROR ES: ", err);
                let localizacionActivada = { resolve: false, posicion: null }
                resolve(localizacionActivada);
              })
          })


        }


      })



      /*  console.log(
         'return de comprobarLocalizacionActivada() ' + localizacionActivada
       );
       console.groupEnd();
       console.log("Retornando");

       return await localizacionActivada; */
    }

    public async comprobarDispositivoConInternet(): Promise<boolean> {
      if (navigator.onLine) {
        this.variables.dispositivoConInternet = true;
      } else {
        this.variables.dispositivoConInternet = false;
      }
      return this.variables.dispositivoConInternet;
    }
}
